import { render, staticRenderFns } from "./PaternityForm.vue?vue&type=template&id=1fbad402"
var script = {}
import style0 from "./PaternityForm.vue?vue&type=style&index=0&id=1fbad402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports